export default "__VITE_ASSET__2907667a__"